import React from 'react';
import PropTypes from 'prop-types';

const { classNames } = Mobi2Go.helpers;

const AddressLoadingIndicator = ({ show }) => {
    return (
        <div
            className={classNames('m2g-customer-address-loading-indicator', {
                'm2g-customer-address-loading-indicator--hidden': !show,
            })}
        >
            <div className="m2g-customer-address-loading-indicator-icon m2g-icon m2g-icon--spinner m2g-icon--large" />
        </div>
    );
};

AddressLoadingIndicator.propTypes = {
    show: PropTypes.bool.isRequired,
};

export default AddressLoadingIndicator;
